import axios from 'axios';
import { API_BASE_URL } from './config';

export const getAllEPMLicenses = async () => {
    const response = await axios.get(`${API_BASE_URL}/epm-license`);
    return response.data;
};

export const getEPMLicense = async (id) => {
    const response = await axios.get(`${API_BASE_URL}/epm-license/${id}`);
    return response.data;
};

export const createEPMLicense = async (licenseData) => {
    const response = await axios.post(`${API_BASE_URL}/epm-license`, licenseData);
    return response.data;
};

export const updateEPMLicense = async (id, licenseData) => {
    const response = await axios.put(`${API_BASE_URL}/epm-license/${id}`, licenseData);
    return response.data;
};

export const deleteEPMLicense = async (id) => {
    const response = await axios.delete(`${API_BASE_URL}/epm-license/${id}`);
    return response.data;
};